import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/readers-and-intercoms/g2-reader-pro.png";
import type { Product } from "../../types";
import { doorAccessReadersIntercom } from "../product-list-groups/doorAccessReadersIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  mobileTap,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "../properties";

export const g2ReaderPro: Product = {
  id: "g2ReaderPro",
  productTitle: "G2 Reader Pro",
  description: "g2ReaderPro.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-g2-pro"],
  storePathParts: {
    category: "door-access-readers",
    collectionSlug: "access-reader-g2-professional",
    productSlug: "ua-g2-pro",
  },
  productListGroup: doorAccessReadersIntercom,
  descriptionMaxWidth: 186,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '160 x 40.4 x 40.55 mm\n(6.3 x 1.59 x 1.6")',
      },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileTap.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "g2ReaderPro.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "readerPowerMethod.poeViaUniFiControlHub",
      },
    },
  ],
  notes: ["g2ReaderPro.note.1"],
};
